/**
 * Created by Ning Jiang on 2/7/2019.
 */

import {BetLinesView} from "@nolimitcity/slot-game/bin/core/betline/BetLinesView";
import {IGameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/IGameConfig";
import {ReelPartCreator} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelPartCreator";
import {ReelSymbolStateCreator} from "@nolimitcity/slot-game/bin/core/reelsymbol/ReelSymbolStateCreator";
import {ISymbolSizeConfig, ISymbolStateConfig} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {IResourcesGroupConfig} from "@nolimitcity/slot-game/bin/core/resource/asset/Asset";
import {IFontsConfig} from "@nolimitcity/slot-game/bin/core/resource/font/IFontsConfig";
import {ISoundConfig} from "@nolimitcity/slot-game/bin/core/resource/sound/ISoundConfig";
import {ParsedGameData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedGameData";
import {ParsedInitData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedInitData";
import {ServerDataParser} from "@nolimitcity/slot-game/bin/core/server/ServerDataParser";
import {IndividualWinPresentationController} from "@nolimitcity/slot-game/bin/core/winpresentation/individualwin/IndividualWinPresentationController";
import {WinPresentationController} from "@nolimitcity/slot-game/bin/core/winpresentation/WinPresentationController";
import {GameTweakerTest} from "@nolimitcity/slot-game/bin/dev/tweaker/test/GameTweakerTest";
import {StillImageBackground} from "@nolimitcity/slot-game/bin/game/background/StillImageBackground";
import {NearWinReelDivider} from "@nolimitcity/slot-game/bin/game/reeldivider/NearWinReelDivider";
import {NoWinSymbolsWinPresentationController} from "@nolimitcity/slot-game/bin/game/winpresentation/nowinsymbols/NoWinSymbolsWinPresentationController";
import {MonkeysGoldFontConfig} from "./MonkeysGoldFontConfig";
import {MonkeysGoldGameAssets} from "./MonkeysGoldGameAssets";
import {MonkeysGoldGameConfig} from "./MonkeysGoldGameConfig";
import {MonkeysGoldSoundConfig} from "./MonkeysGoldSoundConfig";
import {MonkeysGoldServerDataParser} from "./server/MonkeysGoldServerDataParser";
import {MonkeysGoldParsedGameData} from "./server/data/MonkeysGoldParsedGameData";
import {MonkeysGoldParsedInitData} from "./server/data/MonkeysGoldParsedInitData";
import {MonkeysGoldReelSymbol} from "./symbols/MonkeysGoldReelSymbol";
import {MonkeysGoldReelSymbolStateCreator} from "./symbols/MonkeysGoldReelSymbolStateCreator";
import {MonkeysGoldBigWinController} from "./winpresentation/bigwin/MonkeysGoldBigWinController";
import {MonkeysGoldInitialWPController} from "./winpresentation/initial/MonkeysGoldInitialWPController";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {ZeroBetController} from "@nolimitcity/slot-game/bin/core/zerobet/ZeroBetController";
import {AvalancheZeroBetController} from "@nolimitcity/slot-game/bin/game/zerobet/AvalancheZeroBetController";
import {FreespinZeroBetController} from "@nolimitcity/slot-game/bin/game/zerobet/FreespinZeroBetController";
import {FreespinAvalancheZeroBetController} from "@nolimitcity/slot-game/bin/game/zerobet/FreespinAvalancheZeroBetController";
import {MGReelPartAnimator} from "./reel/MGReelPartAnimator";
import {MGReelController} from "./reel/MGReelController";
import {MGIndividualWinController} from "./winpresentation/individualwin/MGIndividualWinController";
import {MonkeysGoldSymbolUpgradeView} from "./winpresentation/symbolsupgradepresentation/MonkeysGoldSymbolUpgradeView";
import {MonkeysGoldSymbolUpgradeController} from "./winpresentation/symbolsupgradepresentation/MonkeysGoldSymbolUpgradeController";
import {ScreenController} from "@nolimitcity/slot-game/bin/core/screen/ScreenController";
import {MonkeysGoldFreeSpinIntroController} from "./screens/freespinintro/MonkeysGoldFreeSpinIntroController";
import {MonkeysGoldFreeSpinIntroView} from "./screens/freespinintro/MonkeysGoldFreeSpinIntroView";
import {MonkeysGoldFreeSpinOutroController} from "./screens/freespinoutro/MonkeysGoldFreeSpinOutroController";
import {MonkeysGoldFreeSpinOutroView} from "./screens/freespinoutro/MonkeysGoldFreeSpinOutroView";
import {ReelStopPresentationController} from "@nolimitcity/slot-game/bin/core/reelstoppresentation/ReelStopPresentationController";
import {MonkeysGoldScatterLandController} from "./reelstoppresentation/scatterland/MonkeysGoldScatterLandController";
import {MonkeysGoldScatterLandView} from "./reelstoppresentation/scatterland/MonkeysGoldScatterLandView";
import {MonkeysGoldRowLockView} from "./reelstoppresentation/rowlock/MonkeysGoldRowLockView";
import {MonkeysGoldRowLockController} from "./reelstoppresentation/rowlock/MonkeysGoldRowLockController";
import {MonkeysGoldBonusGameMultiplierView} from "./winpresentation/bonusgamemultiplier/MonkeysGoldBonusGameMultiplierView";
import {MonkeysGoldBonusGameMultiplierController} from "./winpresentation/bonusgamemultiplier/MonkeysGoldBonusGameMultiplierController";
import {MonkeysGoldColossalMultiplierTextController} from "./symbols/MonkeysGoldColossalMultiplierTextController";
import {MonkeysGoldReelPartCreator} from "./reel/MonkeysGoldReelPartCreator";
import {MonkeysGoldColossalUpgradeAnimationController} from "./symbols/MonkeysGoldColossalUpgradeAnimationController";
import {MonkeysGoldAvalancheSymbolAttentionController} from "./reel/MonkeysGoldAvalancheSymbolAttentionController";
import {MonkeysGoldBackground} from "./background/MonkeysGoldBackground";
import {MonkeysGoldAllReelsFilledWinController} from "./winpresentation/allreelsfilledwin/MonkeysGoldAllReelsFilledWinController";
import {MonkeysGoldRowLockWPController} from "./winpresentation/rowlock/MonkeysGoldRowLockWPController";
import {MonkeysGoldLogo} from "./logo/MonkeysGoldLogo";
import {MonkeysGoldResourceCreateController} from "./resourcecreator/MonkeysGoldResourceCreateController";
import {ReelAreaView} from "@nolimitcity/slot-game/bin/core/reel/reelarea/ReelAreaView";
import {MonkeysGoldReelAreaView} from "./reel/MonkeysGoldReelAreaView";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {MonkeysGoldReels} from "./reel/MonkeysGoldReels";
import {MonkeysGoldSoundController} from "./sound/MonkeysGoldSoundController";
import {MonkeysGoldBigSymbolLandView} from "./reelstoppresentation/bigSymbolLand/MonkeysGoldBigSymbolLandView";
import {MonkeysGoldBigSymbolLandController} from "./reelstoppresentation/bigSymbolLand/MonkeysGoldBigSymbolLandController";
import {MonkeysGoldBigWinView} from "./winpresentation/bigwin/MonkeysGoldBigWinView";
import {MonkeysGoldBonusGameScatterController} from "./winpresentation/bonusGameScatter/MonkeysGoldBonusGameScatterController";
import {MonkeysGoldAllReelsFilledWinView} from "./winpresentation/allreelsfilledwin/MonkeysGoldAllReelsFilledWinView";
import {MonkeysGoldSymbolHighLightController} from "./reelstoppresentation/symbolhighlight/MonkeysGoldSymbolHighLightController";
import {SpinController} from "@nolimitcity/slot-game/bin/core/spin/SpinController";
import {MonkeysGoldSpinController} from "./spin/MonkeysGoldSpinController";
import {IGameModuleConfig} from "@nolimitcity/slot-game/bin/core/gamemoduleconfig/IGameModuleConfig";
import {FeaturePrice} from "./server/data/FeaturePrice";

export class MonkeysGoldGameModuleConfig implements IGameModuleConfig {

    public static instance:MonkeysGoldGameModuleConfig = new MonkeysGoldGameModuleConfig();
    private static gameTweakerTest:GameTweakerTest;
    private static background:StillImageBackground;
    private static reelDivider:NearWinReelDivider;
    private static betLinesView:BetLinesView;
    public static featurePrice:FeaturePrice;

    public static monkeysGoldSymbolUpgradeView:MonkeysGoldSymbolUpgradeView;
    public static monkeysGoldScatterLandView:MonkeysGoldScatterLandView;
    public static monkeysGoldRowLockView:MonkeysGoldRowLockView;
    public static monkeysGoldBonusGameMultiplierView:MonkeysGoldBonusGameMultiplierView;
    public static monkeysGoldColossalMultiplierTextController:MonkeysGoldColossalMultiplierTextController;
    public static monkeysGoldColossalUpgradeAnimationController:MonkeysGoldColossalUpgradeAnimationController;
    public static monkeysGoldAvalancheSymbolAttentionController:MonkeysGoldAvalancheSymbolAttentionController;
    public static monkeysGoldReelPartCreator:MonkeysGoldReelPartCreator;
    public static monkeysGoldRowLockWPController:MonkeysGoldRowLockWPController;
    public static monkeysGoldReelAreaView:MonkeysGoldReelAreaView;
    public static monkeysGoldBackgroundSoundController:MonkeysGoldSoundController;
    public static monkeysGoldScatterLandController:MonkeysGoldScatterLandController;
    public static monkeysGoldBigSymbolLandView:MonkeysGoldBigSymbolLandView;
    public static monkeysGoldBigWinView:MonkeysGoldBigWinView;
    public static monkeysGoldAllReelsFilledWinView:MonkeysGoldAllReelsFilledWinView;

    GAME_CONFIG:IGameConfig = MonkeysGoldGameConfig.instance;
    SOUND_CONFIG:ISoundConfig = MonkeysGoldSoundConfig.instance;
    FONTS_CONFIG:IFontsConfig = MonkeysGoldFontConfig.FONTS;
    RESOURCES_CONFIG:IResourcesGroupConfig = MonkeysGoldGameAssets.RESOURCES_GROUPS;

    SERVER_PARSER:() => ServerDataParser = () => {
        return new MonkeysGoldServerDataParser();
    };
    PARSED_INIT_DATA:(data:any, dataParser:ServerDataParser) => ParsedInitData = (data, dataParser:ServerDataParser) => {
        return new MonkeysGoldParsedInitData(data, <MonkeysGoldServerDataParser>dataParser);
    };
    PARSED_GAME_DATA:(data:any, dataParser:ServerDataParser) => ParsedGameData = (data, dataParser:ServerDataParser) => {
        return new MonkeysGoldParsedGameData(data, <MonkeysGoldServerDataParser>dataParser);
    };

    REEL_AREA_VIEW:() => ReelAreaView = () => {
        return MonkeysGoldGameModuleConfig.monkeysGoldReelAreaView = new MonkeysGoldReelAreaView();
    };

    REEL_CONTROLLER:(reelId:number) => MGReelController = reelId => {
        return new MGReelController(reelId);
    };

    REELS:() => Reels = () => {
        return new MonkeysGoldReels();
    };


    // REEL_VIEW?:(reelId:number) => PIXI.Container; // return type baseView? Default new PIXI.Sprite.

    REEL_PART_ANIMATOR?:(reelId:number) => MGReelPartAnimator = reelId => {
        return new MGReelPartAnimator(reelId);
    }; // Default new SpinReelPartAnimator.

    REEL_PART_CREATOR:() => ReelPartCreator = () => {
        return MonkeysGoldGameModuleConfig.monkeysGoldReelPartCreator = new MonkeysGoldReelPartCreator(
            (symName:string, reelId:number, state?:ISymbolStateConfig, size?:ISymbolSizeConfig):MonkeysGoldReelSymbol => {
                return new MonkeysGoldReelSymbol(symName, reelId, state, size);
            });
    };

    SYMBOL_STATE_CREATOR:() => ReelSymbolStateCreator = () => {
        return new MonkeysGoldReelSymbolStateCreator();
    };

    SCREENS:(() => ScreenController)[] = [
        () => {
            return new MonkeysGoldFreeSpinIntroController({
                viewCreator : (onButtonClickCallback:() => void, autoClose?:boolean) => {
                    return new MonkeysGoldFreeSpinIntroView({
                        layer : MonkeysGoldGameConfig.instance.LAYERS.FREESPIN_INTRO.name,
                        onButtonClickCallback : onButtonClickCallback,
                        buttonBackgroundConfig : {
                            cornerRadius : 12,
                            lineThickness : 2,
                            lineColor : 0xffffff,
                            lineAlpha : 1,
                            backgroundColor : 0x000000,
                            backgroundAlpha : 0.9
                        }
                    }, false);
                }
            });
        },
        () => {
            return new MonkeysGoldFreeSpinOutroController({
                viewCreator : (onButtonClickCallback:() => void, autoClose?:boolean) => {
                    return new MonkeysGoldFreeSpinOutroView({
                        layer : MonkeysGoldGameConfig.instance.LAYERS.FREESPIN_INTRO.name,
                        onButtonClickCallback : onButtonClickCallback,
                        buttonBackgroundConfig : {
                            cornerRadius : 12,
                            lineThickness : 2,
                            lineColor : 0xffffff,
                            lineAlpha : 1,
                            backgroundColor : 0x000000,
                            backgroundAlpha : 0.9
                        }
                    }, false);
                }
            });
        }
    ];

    ZERO_BETS:(() => ZeroBetController)[] = [
        () => new AvalancheZeroBetController(),
        () => new FreespinZeroBetController(),
        () => new FreespinAvalancheZeroBetController()
    ];

    SPIN_CONTROLLER:() => SpinController = () => {
        return new MonkeysGoldSpinController();
    };

    REEL_STOP_PRESENTATIONS:((index:number) => ReelStopPresentationController)[] = [
        index => new MonkeysGoldSymbolHighLightController(index),
        index => MonkeysGoldGameModuleConfig.monkeysGoldScatterLandController = new MonkeysGoldScatterLandController(index),
        index => new MonkeysGoldBigSymbolLandController(index),
        index => new MonkeysGoldRowLockController(index)
    ];

    WIN_PRESENTATIONS:((indexes:[number, number]) => WinPresentationController)[][] = [
        [indexes => MonkeysGoldGameModuleConfig.monkeysGoldRowLockWPController = new MonkeysGoldRowLockWPController(indexes)],
        [indexes => new MonkeysGoldAllReelsFilledWinController(indexes)],
        [indexes => new MonkeysGoldSymbolUpgradeController(indexes)],
        [indexes => {
            return new NoWinSymbolsWinPresentationController(indexes, {noWinStateFadeInDuration : 1});
        }],
        [indexes => new MonkeysGoldBonusGameScatterController(indexes)],
        [indexes => new MonkeysGoldInitialWPController(indexes)],
        [indexes => new MonkeysGoldBigWinController(indexes)],
        [indexes => new MonkeysGoldBonusGameMultiplierController(indexes)],
    ];

    INDIVIDUAL_WIN_PRESENTATION:() => IndividualWinPresentationController = () => {
        return new MGIndividualWinController({
            symbolTimeOffsetCalculator : (currentTotalDuration:number, reelId:number, symbolId:number):number => {
                return 0;
            }
        });
    };

    GAME_FEATURE_CREATOR:() => void = () => {
        const resourceCreator:MonkeysGoldResourceCreateController = new MonkeysGoldResourceCreateController();
        MonkeysGoldGameModuleConfig.monkeysGoldColossalMultiplierTextController = new MonkeysGoldColossalMultiplierTextController();
        MonkeysGoldGameModuleConfig.monkeysGoldColossalUpgradeAnimationController = new MonkeysGoldColossalUpgradeAnimationController();
        MonkeysGoldGameModuleConfig.monkeysGoldAvalancheSymbolAttentionController = new MonkeysGoldAvalancheSymbolAttentionController();
        const logo:MonkeysGoldLogo = new MonkeysGoldLogo();
        MonkeysGoldGameModuleConfig.monkeysGoldBackgroundSoundController = new MonkeysGoldSoundController();
        MonkeysGoldGameModuleConfig.featurePrice = new FeaturePrice();

        MonkeysGoldGameModuleConfig.background = new MonkeysGoldBackground({
            layer : MonkeysGoldGameConfig.instance.LAYERS.BACKGROUND.name,
            backgroundImages : {
                NORMAL : {image : MonkeysGoldGameAssets.MAIN_GAME_BACKGROUND, offset : new PIXI.Point(-480, -480)},
                FREESPIN : {image : MonkeysGoldGameAssets.FS_BACKGROUND, offset : new PIXI.Point(-480, -480)},
                FREESPIN_AVALANCHE : {
                    image : MonkeysGoldGameAssets.FS_BACKGROUND,
                    offset : new PIXI.Point(-480, -480)
                },
                NORMAL_AVALANCHE : {
                    image : MonkeysGoldGameAssets.MAIN_GAME_BACKGROUND,
                    offset : new PIXI.Point(-480, -480)
                }
            },
            stretch : false
        });

        StageManager.legacyScaling = false;
    };

    constructor() {
        if(MonkeysGoldGameModuleConfig.instance) {
            throw new Error("MonkeysGoldGameModuleConfig.constructor() - Instantiation failed: Singleton.");
        }
    }
}